export default __webpack_public_path__ + "static/media/dark-film.737d3bd4.png";